import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { WarrantyPage } from "src/routes/warranty/WarrantyPage";
import { WarrantyTicketPage } from "src/routes/warranty/WarrantyTicketPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { warrantyDetailsRoute, warrantyRoute } from "src/routing/domains/warrantyPaths";

/**
 * `/warranty/*` route tree.
 *
 * Role: data router domain route.
 *
 * Legacy stack (pages still use `PageHeader`, not Beam page layouts):
 * - List: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page
 * - Details: `AppShell` → `GlobalNavLayout` → page (ticket page owns its own scroll/layout)
 * When pages move to `PageHeaderLayout` / `GridTableLayout`, switch to
 * `AppShell` → `BeamNavbarLayout` → page (see `domains/projects.ts`).
 *
 * Path constants live in `warrantyPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` must not register these paths.
 */
const warrantyDomainRoute: RouteObject = {
  path: warrantyRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        { Component: ScrollableParentLayout, children: [{ index: true, Component: WarrantyPage }] },
        // Details skips ScrollableParentLayout (legacy hasOwnLayout); page owns its chrome.
        { path: `${warrantyDetailsRoute.path}/*`, Component: WarrantyTicketPage },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/warranty/*` route trees registered in `Router.tsx`.
 */
export const warrantyRoutes = [warrantyDomainRoute];
